import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NJLeadInspectionsPage = lazy(() => import('../pages/nj-lead-inspections/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const LeadInspectionsPage = lazy(() => import('../pages/lead-inspections/page'));
const AsbestosSurveysPage = lazy(() => import('../pages/asbestos-surveys/page'));
const IndoorAirQualityPage = lazy(() => import('../pages/indoor-air-quality/page'));
const AbatementDesignPage = lazy(() => import('../pages/abatement-design/page'));
const HomeHealthReportPage = lazy(() => import('../pages/home-health-report/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><HomePage /></Suspense>,
  },
  {
    path: '/nj-lead-inspections',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><NJLeadInspectionsPage /></Suspense>,
  },
  {
    path: '/services',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><ServicesPage /></Suspense>,
  },
  {
    path: '/lead-inspections',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><LeadInspectionsPage /></Suspense>,
  },
  {
    path: '/asbestos-surveys',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><AsbestosSurveysPage /></Suspense>,
  },
  {
    path: '/indoor-air-quality',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><IndoorAirQualityPage /></Suspense>,
  },
  {
    path: '/abatement-design',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><AbatementDesignPage /></Suspense>,
  },
  {
    path: '/home-health-report',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><HomeHealthReportPage /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><AboutPage /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><ContactPage /></Suspense>,
  },
  {
    path: '/resources',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><ResourcesPage /></Suspense>,
  },
  {
    path: '*',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div></div>}><NotFound /></Suspense>,
  },
];

export default routes;
